import { screenToBoard } from '@kanvas/board-core';
import { reparentIntoFrames, type ActionContext } from '../actions/actions';
import { editorState, useEditor } from '../state/store';
import { translateNodes, type BoardTemplate } from './templates';

/** Comfortably above the node count of any template authored in this file. */
const RESERVED_INDICES = 64;

/** Drops a template centred under the current viewport, as one undo step. */
export function insertTemplate(ctx: ActionContext, template: BoardTemplate): void {
  const vp = editorState().viewport;
  const center = screenToBoard(vp, { x: vp.width / 2, y: vp.height / 2 });
  const originX = center.x - template.size.w / 2;
  const originY = center.y - template.size.h / 2;

  // Reserved up front so every node keeps the order it was authored in — the
  // frame first, then its contents — rather than all sharing one z key.
  const indices = ctx.doc.topIndices(RESERVED_INDICES);
  let cursor = 0;
  const nextIndex = () => indices[cursor++] ?? ctx.doc.topIndex();

  const nodes = translateNodes(template.build(ctx.identity.userId, nextIndex), originX, originY);
  ctx.doc.addMany(nodes);
  ctx.doc.breakUndoBatch();
  reparentIntoFrames(ctx, nodes.map((n) => n.id));

  const frame = nodes.find((n) => n.type === 'frame');
  useEditor.getState().select(frame ? [frame.id] : []);
}
